module.exports = __webpack_public_path__ + "static/img/4.e12c3b7f.jpg";